import { Modal } from "react-bootstrap";
import { XCircle } from "react-bootstrap-icons";
import { Button } from "../../Controls/Button";
import { HeaderText } from "../../Controls/HeaderText";
import { MonthlyPlateMatchList } from "./MonthlyPlateMatchList";
import { ServerRequestsMonthlyPlateMatch } from "../../shared/api/axios-client";

export interface MonthlyPlateCheckModalProps {
    show: boolean;
    plate: string;
    matches: ServerRequestsMonthlyPlateMatch[];
    loading: boolean;
    onHide: () => void;
}

export function MonthlyPlateCheckModal({
    show,
    plate,
    matches,
    loading,
    onHide,
}: MonthlyPlateCheckModalProps) {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <HeaderText>Monthly parking</HeaderText>
            </Modal.Header>
            <Modal.Body className="p-3">
                {plate && (
                    <div className="text-center mb-3 rounded-3 border bg-light px-3 py-2">
                        <div className="text-muted fw-semibold" style={{ fontSize: "0.65rem", letterSpacing: "0.12em", textTransform: "uppercase" }}>
                            Plate
                        </div>
                        <span className="fw-bold" style={{ fontSize: "1.5rem", letterSpacing: "0.04em", fontFamily: "monospace" }}>
                            {plate.trim().toUpperCase()}
                        </span>
                    </div>
                )}
                {loading ? (
                    <div className="text-center text-muted py-4">Checking monthly parking...</div>
                ) : matches.length === 0 ? (
                    <div className="d-flex flex-column align-items-center text-center py-4 gap-3">
                        <div
                            className="rounded-circle d-flex align-items-center justify-content-center"
                            style={{ width: 64, height: 64, background: "rgba(214,31,132,0.1)" }}
                        >
                            <XCircle style={{ fontSize: 28, color: "#D61F84" }} />
                        </div>
                        <div>
                            <div className="fw-semibold mb-1">No monthly parking matches</div>
                            <div className="text-muted small">
                                This plate is not on an active monthly subscription at this facility.
                            </div>
                        </div>
                    </div>
                ) : (
                    <MonthlyPlateMatchList matches={matches} />
                )}
                <div className="d-flex justify-content-end">
                    <Button type="button" className="rounded-4" onClick={onHide}>
                        Dismiss
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
}
